import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

export const LogoStaff = props => {
  const { sx, url } = props;
  const navigate = useNavigate();

  return (
    // <Box
    //   onClick={() => url ? window.location.assign(url) : navigate('/')}
    //   component="img"
    //   src="/static/SUN SPORT LOGOS-01.png"
    //   sx={{ cursor: 'pointer', width: 200, height: 80, ...sx, objectFit: 'contain' }} />
    <Box />
  );
};
LogoStaff.propTypes = {
  sx: PropTypes.object
};
